import { render, staticRenderFns } from "./add-template-modal.vue?vue&type=template&id=52ffd094&scoped=true"
import script from "./add-template-modal.vue?vue&type=script&lang=js"
export * from "./add-template-modal.vue?vue&type=script&lang=js"
import style0 from "./add-template-modal.vue?vue&type=style&index=0&id=52ffd094&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ffd094",
  null
  
)

export default component.exports